'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var ReactDOM = require('react-dom');
var index$1 = require('./store/index.js');
var index$2 = require('./Wizard/index.js');
var index = require('./WizardStep/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var WizardContainer = function WizardContainer(_ref) {
  var backButton = _ref.backButton,
      children = _ref.children,
      className = _ref.className,
      container = _ref.container,
      finishButton = _ref.finishButton,
      forwardButton = _ref.forwardButton,
      onClose = _ref.onClose,
      onFinish = _ref.onFinish,
      onForward = _ref.onForward,
      title = _ref.title;
  return ReactDOM.createPortal( /*#__PURE__*/React__default['default'].createElement(index$1.StoreProvider, {
    onFinish: onFinish,
    onForward: onForward
  }, /*#__PURE__*/React__default['default'].createElement(index$2, {
    backButton: backButton,
    className: className,
    finishButton: finishButton,
    forwardButton: forwardButton,
    onClose: onClose,
    title: title
  }, children)), container || document.body);
};

WizardContainer.propTypes = {
  backButton: PropTypes__default['default'].string.isRequired,
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].arrayOf(PropTypes__default['default'].node), PropTypes__default['default'].node]),
  className: PropTypes__default['default'].string,
  container: PropTypes__default['default'].element,
  finishButton: PropTypes__default['default'].string.isRequired,
  forwardButton: PropTypes__default['default'].string.isRequired,
  onClose: PropTypes__default['default'].func.isRequired,
  onFinish: PropTypes__default['default'].func.isRequired,
  onForward: PropTypes__default['default'].func.isRequired,
  title: PropTypes__default['default'].string.isRequired
};
WizardContainer.defaultProps = {
  children: null,
  className: undefined,
  container: undefined
};

exports.WizardStep = index;
exports.default = WizardContainer;
